import Component, { mixins } from 'vue-class-component'

import WithRender from './GestionFicheRepondantPage.html'

import {
  MPanel
} from '@ulaval/modul-components'

import SessionSelect from '../global/session/SessionSelect'
import FicheRepondantBreadcrumbs from './breadcrumbs/FicheRepondantBreadcrumbs'

@WithRender
@Component({
  components: {
    FicheRepondantBreadcrumbs,
    MPanel,
    SessionSelect
  }
})
export default class GestionFicheRepondantPage extends mixins() {

}
